module.exports = __webpack_public_path__ + "img/logo.5584a160.png";